import {
  RsVorbelegungdaten,
  VermietetesBebautesObjekt,
  VermietetesObjekt,
  VermietetesObjektEnum,
  VermietetesUnbebautesObjekt,
} from '@ps20-frontend/frontend-models';

export function getBebauteObjekte(
  actionPayload: RsVorbelegungdaten,
  sectionState: Array<VermietetesObjekt>,
): void {
  actionPayload.bebauteGebaeude.forEach(value => {
    const bebautesObjekt: VermietetesBebautesObjekt = {
      grundstueckBebaut: VermietetesObjektEnum.BEBAUT,
      wohneinheiten: value.anzahlWohneinheiten ? value.anzahlWohneinheiten : 0,
      bruttojahresmieteWohneinheiten: value.bruttoJahresMieteWohnungen,
      gewerbeeinheiten: value.anzahlGewerbeeinheiten ? value.anzahlGewerbeeinheiten : 0,
      bruttojahresmieteGewerbeeinheiten: value.bruttoJahresMieteGewerbe,
      stellplaetze: value.anzahlGaragen ? value.anzahlGaragen : 0,
      bruttojahresmieteStellplaetze: value.bruttoJahresMieteGarage,
      hausnummer: value.adresse.hausnummer,
      strasse: value.adresse.strasse,
      plz: value.adresse.plz,
      ort: value.adresse.ort,
      deltafaktorGarage: value.deltafaktorGarage,
      deltafaktorGewerbe: value.deltafaktorGewerbe,
      deltafaktorWohnung: value.deltafaktorWohnung,
      plzFaktorGarage: value.plzFaktorGarage,
      plzFaktorGewerbe: value.plzFaktorGewerbe,
      plzFaktorWohnung: value.plzFaktorWohnung,
      instanzIdGarage: value.instanzIdGarage,
      instanzIdGewerbe: value.instanzIdGewerbe,
      instanzIdWohnung: value.instanzIdWohnung,
      vorbelegt: true,
    } as VermietetesBebautesObjekt;
    sectionState.push(bebautesObjekt);
  });
}

export function getUnbebauteObjekte(
  actionPayload: RsVorbelegungdaten,
  sectionState: Array<VermietetesObjekt>,
): void {
  actionPayload.unbebauteGrundstuecke.forEach(value => {
    const unbebautesObjekt: VermietetesUnbebautesObjekt = {
      grundstueckBebaut: VermietetesObjektEnum.UNBEBAUT,
      flurstueckNummer: value.flurstueckNummer,
      grundstueckFlaeche: value.flaeche,
      hausnummer: value.adresse.hausnummer,
      strasse: value.adresse.strasse,
      plz: value.adresse.plz,
      ort: value.adresse.ort,
      deltafaktorUnbebaut: value.deltafaktorUnbebaut,
      plzFaktorUnbebaut: value.plzFaktorUnbebaut,
      instanzIdUnbebaut: value.instanzIdUnbebaut,
      vorbelegt: true,
    } as VermietetesUnbebautesObjekt;
    sectionState.push(unbebautesObjekt);
  });
}
